import styled from 'styled-components';

export const PaginationDiV = styled.div`
  display: flex;
  max-width: 500px;
  width: 30%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 50px;
  margin-bottom: 50px;
  align-self: flex-end;
`;
export const PaginationItem = styled.div``;
export const PaginationItemP = styled.p`
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-left: 15px;
  cursor: pointer;
  background-color: #f9f5ff;
  height: 40px;
  width: 40px;
  color: #7f56d9;
`;
export const PaginationItemP2 = styled.p`
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-left: 15px;
  cursor: pointer;
  height: 40px;
  width: 40px;
  color: #6669;
`;
